<div class="flex w-full flex-row h-full">
  <app-auth-banner class="absolute flex-1 w-full h-full">
    <!-- <div class="flex flex-col gap-4 text-white">
      <div class="text-4xl font-semibold">
        {{ localization.auth.sign_up_title | translate }}
      </div>
      <div class="text-lg">
        {{ localization.auth.sign_up_slogan | translate }}
      </div>
    </div> -->
  </app-auth-banner>

  <div class="wrapper">
    <div class="flex flex-col w-full max-w-xl sm:w-full gap-6 justify-center m-auto">
      <div class="flex flex-col gap-4 mb-6">
        <div class="text-3xl font-semibold text-center">
          Join {{ inviteParams.business_name | titlecase }}
          <!-- {{ localization.auth.sign_up_title | translate }} -->
        </div>
        <!-- <div class="text-md">
          {{ localization.auth.sign_up_slogan | translate }}
        </div> -->
      </div>


      <form
        class="flex flex-col gap-7"
        [formGroup]="infomationForm"
        (ngSubmit)="onFormSubmit()"
      >
        <!-- ----------------------------- first name ------------------------------ -->
        <div>
          <app-text-input
            formControlName="firstname"
            [label]="localization.labels.first_name | translate"
            [placeholder]="localization.labels.first_name | translate"
            [invalid]="infomationForm.get('firstname')!.touched && infomationForm.get('firstname')!.invalid"
          ></app-text-input>
          <!-- <app-error-text
            class="mt-1"
            *ngIf="infomationForm.get('first_name')?.getError('minLength')"
          >
            {{ localization.errors.inva | translate }}
          </app-error-text> -->
          <app-error-text
            class="mt-1"
            *ngIf="infomationForm.get('firstname')?.getError('required') && !infomationForm.get('firstname')?.pristine"
          >
            {{ localization.errors.first_name_required | translate }}
          </app-error-text>
        </div>

        <!-- ------------------------------ last name ------------------------------ -->
        <div>
          <app-text-input
            formControlName="lastname"
            [label]="localization.labels.last_name | translate"
            [placeholder]="localization.labels.last_name | translate"
            [invalid]="infomationForm.get('lastname')!.touched && infomationForm.get('lastname')!.invalid"
          ></app-text-input>
          <!-- <app-error-text
            class="mt-1"
            *ngIf="infomationForm.get('last_name')?.getError('minLength')"
          >
            {{ localization.errors.inva | translate }}
          </app-error-text> -->
          <app-error-text
            class="mt-1"
            *ngIf="infomationForm.get('lastname')?.getError('required') && !infomationForm.get('lastname')?.pristine"
          >
            {{ localization.errors.last_name_required | translate }}
          </app-error-text>
        </div>

        <!-- --------------------------- business email ---------------------------- -->
        <div>
          <app-text-input
            [disabled]="true"
            formControlName="email"
            [label]="localization.terms.email | translate"
            [placeholder]="localization.placeholder.type_your_email | translate"
          ></app-text-input>
        </div>

        <!-- ------------------------------ password ------------------------------- -->
        <div class="flex flex-col gap-3 text-zinc-800">
          <app-password-input
            [placeholder]="localization.placeholder.create_your_password | translate"
            [label]="localization.terms.password| translate"
            formControlName="password"
            (blur)="infomationForm.get('password')!.invalid && (passwordRestrictions = true)"
          ></app-password-input>
          <div
            class="flex items-center gap-2 cursor-pointer hover:underline"
            (click)="passwordRestrictions = !passwordRestrictions"
          >
            <span
              style="max-width: 70vw;"
              class="truncate"
            >
              Must be at least 8 characters long, include at least one lowercase and one uppercase letter, one
              digit, and one special character.
            </span>
            <img
              src="assets/icons/new-set/chevron-down.svg"
              [ngClass]="{'rotate-180': passwordRestrictions}"
              class="h-6 svg-gray-filter "
              alt=""
            >
          </div>
          <div
            class="criteria-container"
            *ngIf="passwordRestrictions"
          >
            <p class="font-semibold">{{localization.auth.must_contain | translate}}:</p>
            <p [class.validCriteria]="!infomationForm.get('password')!.getError('lowercase')">
              {{localization.auth.one_lowercase_letter_restriction | translate}}
            </p>
            <p [class.validCriteria]="!infomationForm.get('password')!.getError('uppercase')">
              {{localization.auth.one_uppercase_letter_restriction | translate}}
            </p>
            <p [class.validCriteria]="!infomationForm.get('password')!.getError('digit')">
              {{localization.auth.one_digit_restriction | translate}}
            </p>
            <p [class.validCriteria]="!infomationForm.get('password')!.getError('specialchar')">
              {{localization.auth.one_special_character_restriction | translate}}
            </p>
            <p [class.validCriteria]="!infomationForm.get('password')!.getError('minLength')">
              {{localization.auth.eight_character_restriction | translate}}
            </p>
          </div>
        </div>

        <div class="text-center text-lg px-4">
          <ng-container *ngFor="let item of localization.auth.sign_up_tos  | translate | translateCut; let i = index">
            <ng-container [ngSwitch]="item.type">
              <span *ngSwitchCase="'text'">
                {{ item.content }}
              </span>
              <span
                *ngSwitchCase="'section'"
                class="text-primary font-semibold cursor-pointer"
                (click)="i == 1 ? openTermsAndConditions() : openPrivacyPolicy()"
              >
                {{ item.content }}
              </span>
            </ng-container>
          </ng-container>
        </div>

        <div class="mt-2">
          <app-button
            class="w-full mt-2"
            type="submit"
          >
            <ng-container *ngIf="!(singUpState$ | async)?.loading; else loading">
              {{ localization.auth.agree_and_join | translate: { businessname: inviteParams.business_name } }}
            </ng-container>
            <ng-template #loading>
              <span>
                <svg
                  class="mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              </span>
            </ng-template>
          </app-button>
        </div>
      </form>

      <!-- <div class="flex gap-3 mt-8 justify-center">
        {{ localization.auth.have_account | translate }}
        <span
          class="cursor-pointer text-primary font-semibold"
          routerLink="/auth/login"
        >
          {{ localization.auth.sign_in | translate }}
        </span>
      </div> -->
    </div>
  </div>
</div>